import { RibbonGroupBase } from '../ribbon-interfaces';
export const PAGE_BREAK_ID = '_page_break';
/**
 * Pages group implementation for Insert tab
 * @private
 */
export class PagesGroup extends RibbonGroupBase {
    /**
     * Get the Ribbon items for Pages group
     * @returns {RibbonGroupModel} - Pages group model
     * @private
     */
    getGroupModel() {
        return {
            header: this.localObj.getConstant('Pages'),
            groupIconCss: 'e-icons e-de-ctnr-page-break',
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Pages'),
            collections: [{
                    items: [{
                            type: 'Button',
                            keyTip: 'B',
                            buttonSettings: {
                                content: this.localObj.getConstant('Page Break'),
                                iconCss: 'e-icons e-de-ctnr-page-break',
                                isToggle: false,
                                clicked: this.insertPageBreakHandler.bind(this)
                            },
                            id: this.ribbonId + PAGE_BREAK_ID,
                            ribbonTooltipSettings: {
                                // title: this.localObj.getConstant('Page Break'),
                                content: this.localObj.getConstant('Insert a page break at the current position')
                            }
                        }]
                }]
        };
    }
    insertPageBreakHandler() {
        this.documentEditor.editorModule.insertPageBreak();
    }
    /**
     * Update selection to reflect current state
     * @returns {void}
     * @private
     */
    updateSelection() {
        const isHeaderFooter = this.documentEditor.selection.contextType.indexOf('Header') >= 0 ||
            this.documentEditor.selection.contextType.indexOf('Footer') >= 0;
        const isInTable = this.documentEditor.selection.contextType.indexOf('Table') >= 0;
        const ribbon = this.container.ribbon.ribbon;
        if (ribbon) {
            if (isInTable || isHeaderFooter || this.container.documentEditor.selection.isinFootnote
                || this.container.documentEditor.selection.isinEndnote || this.container.documentEditor.selection.isInShape) {
                ribbon.disableItem(this.ribbonId + PAGE_BREAK_ID);
            }
            else {
                ribbon.enableItem(this.ribbonId + PAGE_BREAK_ID);
            }
        }
    }
}
